/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ResolveSpeedSelectionBlockerRequest} from '@cash-web/protos/squareup/cash/out/api/v2_0/ResolveSpeedSelectionBlocker.pb'
import {ResolveSpeedSelectionBlockerResponse} from '@cash-web/protos/squareup/cash/out/api/v2_0/ResolveSpeedSelectionBlocker.pb'


export const resolveCashOutSpeedSelectionBlocker = (request:ResolveSpeedSelectionBlockerRequest, options?: CashRequestOptions) => post<ResolveSpeedSelectionBlockerRequest, ResolveSpeedSelectionBlockerResponse>("/2.0/cash/resolve-cash-out-speed-selection-blocker", request, {...options, rejectOnError: true })